<template>
    <el-table-draggable handle=".handle" :animate="300" @drop="onChangeSort" size="small">
        <el-table :data="data" ref="table" empty-text="無資料" style="width: 100%" class="subtable" :show-header="false">
            <el-table-column width="25" class-name="expand"> </el-table-column>

            <el-table-column prop="name" label="項目" width="265" class-name="header">
                <template slot-scope="scope">
                    <div class="name">
                        <div class="handle">
                            <div v-for="i in 2" :key="i" />
                        </div>
                        <div class="item-name" @click="$emit('item-click', scope.row.sno)" style="padding: 0 10px;">{{ scope.row.name }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column key="1" prop="openingBalance" label="期初金額" align="right" v-if="columnDisplayList.includes('期初金額')">
                <template slot-scope="scope">
                    <Money :v="scope.row.openingBalance" zero="-" round />
                </template>
            </el-table-column>
            <el-table-column key="2" prop="operatingRevenue" label="本期收入" align="right" v-if="columnDisplayList.includes('本期收入')">
                <template slot-scope="scope">
                    <Money :v="scope.row.operatingRevenue" zero="-" round />
                </template>
            </el-table-column>
            <el-table-column key="3" prop="operatingCosts" label="本期支出" align="right" v-if="columnDisplayList.includes('本期支出')">
                <template slot-scope="scope">
                    <Money :v="scope.row.operatingCosts" zero="-" round />
                </template>
            </el-table-column>
            <el-table-column key="4" prop="netIncome" label="本期增減" align="right" v-if="columnDisplayList.includes('本期增減')">
                <template slot-scope="scope">
                    <Money
                        :v="scope.row.netIncome"
                        zero="-"
                        round
                        :showPositivePlus="true"
                        :class="{
                            increase: scope.row.netIncome > 0,
                            decrease: scope.row.netIncome < 0
                        }"
                    />
                </template>
            </el-table-column>
            <el-table-column key="5" prop="totalAmount" label="本期餘額" align="right">
                <template slot-scope="scope">
                    <Money :v="scope.row.totalAmount" zero="-" round />
                </template>
            </el-table-column>
        </el-table>
    </el-table-draggable>
</template>

<script>
import _ from 'lodash';
import ElTableDraggable from 'element-ui-el-table-draggable';

export default {
    components: { ElTableDraggable },
    props: {
        data: {
            type: Array,
            default: () => [],
        },
        groupNo: {
            type: Number,
            default: 0,
        },
        columnDisplayList: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        async onChangeSort() {
            const sorted = _.map(this.data, (o, i) => ({
                sno: o.sno,
                sot: i,
            }));
            try {
                this.$emit('toggleLoading');
                await this.$api({
                    url: 'FinancialStatement/UpdateSort',
                    method: 'POST',
                    data: {
                        grP_NAM: this.groupNo,
                        items: sorted,
                    },
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.$emit('toggleLoading');
            }
        },
    },
};
</script>

<style lang="scss">
.subtable {
    &.el-table td.el-table__cell {
        padding: 3px 0;
        font-size: 10pt;

        &:first-child {
            padding-left: 15px;
        }
    }

    &.hover-row {
        td {
            background-color: #eaeff8;
        }
    }

    .name {
        display: flex;
        align-items: center;
        .handle {
            position: relative;
            width: 15px;
            height: 30px;
            margin-left: 15px;
            margin-right: 10px;
            > * {
                position: absolute;
                width: 100%;
                height: 2px;
                background-color: #ddd;
            }
            :nth-child(1) {
                top: calc(50% - 3px);
            }
            :nth-child(2) {
                top: calc(50% + 3px);
            }
        }
        .item-name {
            cursor: pointer;

            &:hover {
                color: #463cb2;
                text-decoration: underline;
            }
        }
    }
}
</style>
